const MONTH_ABBR = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// d MMM yyyy in South African time, for example "23 Nov 2026". Month names are
// fixed here because browsers differ ("Sept" or "Sep") for the same locale.
export function formatBillingDate(value: string | number | Date | null | undefined): string {
    if (value === null || value === undefined || value === "") return "";
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    const parts = new Intl.DateTimeFormat("en-GB", {
        timeZone: "Africa/Johannesburg",
        year: "numeric",
        month: "numeric",
        day: "numeric",
    }).formatToParts(date);
    const get = (type: string) => Number(parts.find((p) => p.type === type)?.value);
    return `${get("day")} ${MONTH_ABBR[get("month") - 1]} ${get("year")}`;
}
